import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialStateFabricator = {
    Fabricator: [],
    assignpayment: [],
    Userfab: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getFabricator = createAsyncThunk(
    'fabricator/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
             const getuserId = localStorage.getItem("id");
            const response = await axiosInstance.get(BASE_URL + '/getAllFabricator/' + getuserId, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addFabricator = createAsyncThunk(
    'fabricator/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data, "data=====");
        try {
            const { fabricatorImage, MultipleImages, fabricatorDetails, ...rest } = data;
            const formData = new FormData();

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            if (Array.isArray(fabricatorDetails) && fabricatorDetails.length > 0) {
                fabricatorDetails.forEach((detail, index) => {
                    const formattedDetail = formatFabricatorDetail(detail);
                    Object.keys(formattedDetail).forEach(key => {
                        if (formattedDetail[key] !== null && formattedDetail[key] !== '') {
                            formData.append(`fabricatorDetails[${index}][${key}]`, formattedDetail[key]);
                        }
                    });
                });
            } else {
                formData.append('fabricatorDetails', null);
            }

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (fabricatorImage) {
                fabricatorImage.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('fabricatorImage', file);
                        formData.append(`fabricatorImageIndex_${formData.getAll('fabricatorImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`ExistingfabricatorImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/createFabricator', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data, "response.data.fabricator");
            dispatch(getFabricator());
            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteFabricator = createAsyncThunk(
    'fabricator/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteFabricator/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getFabricator());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getFabricatorById = createAsyncThunk(
    'fabricator/view',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getFabricatorById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.Fabricator, "response.data.Fabricator");
            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editFabricator = createAsyncThunk(
    'fabricator/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data, "data=====");
        try {
            const { _id, MultipleImages, fabricatorImage, fabricatorDetails, ...rest } = data;

            const formData = new FormData();
            formData.append('_id', _id);

            // Append all PaymentDetails, including existing ones

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            if (Array.isArray(fabricatorDetails) && fabricatorDetails.length > 0) {
                fabricatorDetails.forEach((detail, index) => {
                    const formattedDetail = formatFabricatorDetail(detail);

                    Object.keys(formattedDetail).forEach(key => {
                        if (formattedDetail[key] !== null && formattedDetail[key] !== '') {
                            formData.append(`fabricatorDetails[${index}][${key}]`, formattedDetail[key]);
                        }
                    });

                    const formattedDetailSecond = formatFabricatorDetail(detail);
                    Object.keys(formattedDetailSecond).forEach(key => {
                        if (formattedDetailSecond[key] !== null && formattedDetailSecond[key] !== '') {
                            formData.append(`fabricatorDetailsSecond[${index}][${key}]`, formattedDetailSecond[key]);
                        }
                    });
                });
            } else {
                formData.append('fabricatorDetails', null);
            }

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (fabricatorImage) {
                fabricatorImage.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('fabricatorImage', file);
                        formData.append(`fabricatorImageIndex_${formData.getAll('fabricatorImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingfabricatorImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.put(`${BASE_URL}/updateFabricator/${_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data.fabricator);
            dispatch(getFabricator());
            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

// Function to format fabricator details
const formatFabricatorDetail = (detail) => ({
    fabricatorCatogory: detail.fabricatorCatogory || null,
    fabricatorSubCatogory: detail.fabricatorSubCatogory ? detail.fabricatorSubCatogory.trim() : null,
    fabricatorProductName: detail.fabricatorProductName ? detail.fabricatorProductName.trim() : null,
    fabricatorQty: detail.fabricatorQty || null,
});



export const updateFabricatorStatus = createAsyncThunk(
    'fabricator/updateFabricatorStatus',
    async ({ ids, submitDate }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${BASE_URL}/updateFabricatorStatus`, {ids, submitDate }, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // dispatch(getFabricator());
            // console.log(response.data);
            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getInstallerInFab = createAsyncThunk(
    'InstallerInFab/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getInstallerInFab', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.assign;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getAssignInPayment = createAsyncThunk(
    'InstallerInPayment/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAssignInPayment', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.assign;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getcategoryInFab = createAsyncThunk(
    'fabCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getfabCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getsubcategoryInFab = createAsyncThunk(
    'fabsubCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getfabSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getproductInFab = createAsyncThunk(
    'fabproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getfabProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getuserInFab = createAsyncThunk(
    'fabUser/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getfabUser', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.Userfab;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const fabricatorSlice = createSlice({
    name: 'fabricator',
    initialState: initialStateFabricator,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.Fabricator = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(addFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Fabricators...';
            })
            .addCase(addFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Fabricator.push(action.payload);
                state.message = action.payload?.message || 'Fabricator added successfully';
            })
            .addCase(addFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Fabricator';
            })
            .addCase(deleteFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Fabricator...';
            })
            .addCase(deleteFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Fabricator = state.Fabricator.filter((fabricator) => fabricator._id !== action.payload);
                state.message = action.payload?.message || 'Fabricator deleted successfully';
            })
            .addCase(deleteFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Fabricator';
            })
            .addCase(editFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Fabricator...';
            })
            .addCase(editFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Fabricator)) {
                    state.Fabricator = state.Fabricator.map(fabricator =>
                        fabricator._id === action.payload?._id ? action.payload : fabricator
                    );
                }
                state.message = 'Fabricator updated successfully';
            })
            .addCase(editFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Fabricator';
            })
            .addCase(getFabricatorById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricator...';
            })
            .addCase(getFabricatorById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricator fetched successfully';
                state.Fabricator = action.payload;
            })
            .addCase(getFabricatorById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricator';
            })

            .addCase(updateFabricatorStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Fabricator Status...';
            })
            .addCase(updateFabricatorStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricator status updated successfully';
                // state.Fabricator = state.Fabricator.map(fabricator =>
                //     fabricator._id === action.payload?._id ? action.payload : fabricator
                // );
                // dispatch(getFabricator());
            })
            .addCase(updateFabricatorStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Fabricator status';
            })
            .addCase(getInstallerInFab.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getInstallerInFab.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.assign = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getInstallerInFab.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getAssignInPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getAssignInPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.assignpayment = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAssignInPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getcategoryInFab.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getcategoryInFab.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getcategoryInFab.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getsubcategoryInFab.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getsubcategoryInFab.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getsubcategoryInFab.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getproductInFab.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getproductInFab.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getproductInFab.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getuserInFab.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getuserInFab.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.Userfab = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getuserInFab.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
    }
});

export default fabricatorSlice.reducer;